import {
  Component,
  DoCheck,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { CaseView } from 'src/app/digigov/models/caseview.model';
import { DatePipe } from '@angular/common';
import { AppInitService } from 'src/app/digigov/services/app-init.service';

export class customData {
  selectedData: CaseView[];
  isFromCustomAction: boolean;
}

@Component({
  selector: 'app-dg-await',
  templateUrl: './dg-await.component.html',
  styleUrls: ['./dg-await.component.scss'],
})
export class DgAwaitComponent implements OnInit, DoCheck {
  @Input() caseData: CaseView[];
  @Input() configuredJson = null;
  @Input() isFromCustomAction = false;
  docId: number;
  str: string;
  postData = [];
  minDate: Date;
  awaitPeriodRequired = false;
  constructor(
    private http: HttpClient,
    public datepipe: DatePipe,
    private appInitService: AppInitService,
    @Inject(MAT_DIALOG_DATA) public data: customData,
    public dialogRef: MatDialogRef<DgAwaitComponent>
  ) {
    const today = new Date();
    const tommorrow = new Date(today);
    tommorrow.setDate(today.getDate() + 1);
    this.minDate = tommorrow;
  }

  ngDoCheck(): void {}

  expForm: FormGroup;
  @Output() resultData = new EventEmitter<any>();
  @Output() isFormValid = new EventEmitter<any>();
  ngOnInit(): void {
    this.isFormValid.emit(false);
    this.caseData = this.data?.selectedData;
    this.awaitPeriodRequired = this.appInitService?.appConfig
      ?.configurableFields['awaitPeriodRequired']
      ? this.appInitService?.appConfig?.configurableFields[
          'awaitPeriodRequired'
        ]
      : false;
    this.expForm = new FormGroup({
      reason: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^[^#]+$/),
      ]),
      awaitperiod: new FormControl(null),
    });
    if (this.configuredJson?.customActionData?.reasonForAwait) {
      this.expForm?.controls?.reason?.setValue(
        this.configuredJson?.customActionData?.reasonForAwait
      );
      this.str = this.configuredJson?.customActionData?.reasonForAwait;
    }
  }

  /* postData={
    "extendedVO": null,
    "customXidBean": null,
    "dbSchema": null,
    "recID": null,
    "appTypeID": 0,
    "typeFlag": 0,
    "initialRequest": null,
    "finalDecision": "Await the Case",
    "implictinFaced": null,
    "remarks": "Await it",
    "locID": -1,
    "fromPostID": -1,
    "appliedByPostID": -1,
    "classificationId": -1,
    "langId": -1,
    "empId": -1,
    "disposeFrom": "",
    "recIdArr": null,
    "delegationVO": null,
    "notingsId": null,
    "notingCntr": 0,
    "frmFpocDispose": false,
    "disposed": false
}*/

  formInvalid() {
    return this.expForm.invalid;
  }
  onAwait(): void {
    let date = new Date();
    let awaitPeriod;
    if (this.awaitPeriodRequired) {
      awaitPeriod = this.expForm.controls['awaitperiod'].value;
    }
    this.isFormValid.emit(this.str?.length > 0 ? true : false);
    try {
      if (this.caseData[0]?.docId) {
        if (this.expForm.valid) {
          if (this.awaitPeriodRequired) {
            this.caseData = this.data?.selectedData;
            this.caseData.forEach((ele) => {
              this.docId = ele.docId;
              this.postData.push({
                recId: Number(this.docId),
                appTypeId: this.caseData[0]?.appTypeId,
                reason: this.str,
                awaitDateValue: this.datepipe.transform(
                  date,
                  'dd-MMM-yyyy HH:mm:ss'
                ),
                awaitPeriod: this.awaitPeriodRequired
                  ? this.datepipe.transform(awaitPeriod, 'dd-MMM-yyyy HH:mm:ss')
                  : null,
              });
            });
          } else {
            this.caseData = this.data?.selectedData;
            this.caseData.forEach((ele) => {
              this.docId = ele.docId;
              this.postData.push({
                recId: Number(this.docId),
                appTypeId: this.caseData[0]?.appTypeId,
                reason: this.str,
                awaitDateValue: this.datepipe.transform(date, 'dd-MMM-yyyy'),
              });
            });
          }

          if (!this.data?.isFromCustomAction) {
            this.http
              .post('/case-mgmnt/await-case', this.postData)
              .subscribe((res) => {
                this.dialogRef.close(true);
              });
          } else {
            this.resultData.emit({
              awaitVO: this.postData,
              customActionData: { reasonForAwait: this.str },
            });
            try {
              this.dialogRef.close({
                awaitVO: this.postData,
                customActionData: { reasonForAwait: this.str },
              });
            } catch (e) {}
          }
        }
      } else {
        try {
          if (!this.caseData[0]?.docId) {
            this.resultData.emit({
              awaitVO: this.postData,
              customActionData: { reasonForAwait: this.str },
            });
          }
        } catch (e) {}
      }
    } catch (e) {
      this.resultData.emit({
        awaitVO: this.postData,
        customActionData: { reasonForAwait: this.str },
      });
    }
  }
}
